import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {TabsComponent} from '../tabs/tabs.component';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit, OnDestroy {

  @Input()
  tabTextKey: string;

  @Input()
  tabTextParams: Object;

  @Input()
  faIcon: string;

  @Input()
  tabId: string;

  @Input()
  disabled: boolean;

  @Input()
  withAlert: boolean;

  @Input()
  selected: boolean;

  @Output()
  selectedChange = new EventEmitter<boolean>();

  @Input()
  navigate: () => void = () => {};

  constructor(private tabsComponent: TabsComponent) { }

  ngOnInit() {
    this.tabsComponent.addTab(this);
  }

  ngOnDestroy(): void {
    this.tabsComponent.removeTab(this);
  }

  select() {
    this.selected = true;
    this.selectedChange.emit(this.selected);
  }

  unselect() {
    this.selected = false;
    this.selectedChange.emit(this.selected);
  }
}
